import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useHistory } from 'react-router';
import { HiddenAnnotationsToastContainer } from '../../../containers/HiddenAnnotationsToast.container';
import { Home } from '../../../routes/config/Home';
import { IAnnotationsStore } from '../../annotation/annotations.store';
import { Image } from '../../annotation/components/Image';
import { DrawingContainer } from '../../annotation/containers/Drawing.container';
import { ImageContainer } from '../../annotation/containers/Image.container';
import { SegmentationsContainer } from '../../annotation/containers/Segmentations.container';
import { ImageDeletedMessage } from '../components/ImageDeletedMessage';
import { IFreeAccessService } from '../freeAccess.service';
import { FreeAccessMode, IFreeAccessStore } from '../freeAccess.store';

interface IProps {
  imageId: string;
  projectId: string;
  filterId: string;
  workspaceId: string;
  isReadOnly: boolean;
}

export const FreeAccessImageSetupContainer = observer((props: IProps): ReactElement => {
  const freeAccessStore = useInjection(IFreeAccessStore.$);
  const freeAccessService = useInjection(IFreeAccessService.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const history = useHistory();

  const { imageId, projectId, filterId, workspaceId, isReadOnly } = props;

  useEffect(() => {
    freeAccessStore.paging = {
      checkDate: '',
      wasChanged: true,
      items: [],
    };

    return (): void => {
      annotationsStore.questions.replace([]);
      annotationsStore.selectedSegmentation = undefined;
      freeAccessService.dispose();
    };
  }, []);

  useEffect(() => {
    void setupService();
  }, [imageId]);

  const setupService = async (): Promise<void> => {
    await freeAccessService.initializeAsync(workspaceId, projectId, imageId, filterId, FreeAccessMode.VIEW);
  };

  const handleRefresh = (): void => {
    history.push(Home.Projects.Details.Images.withParams({ projectId, workspaceId }));
  };

  return freeAccessStore.showImageDeletedMessage ? (
    <ImageDeletedMessage onRefresh={handleRefresh} />
  ) : (
    <>
      <HiddenAnnotationsToastContainer />
      <ImageContainer>
        {(imageProps): ReactElement => (
          <Image {...imageProps}>
            <SegmentationsContainer readonly={isReadOnly} />
            {!isReadOnly && <DrawingContainer disableCursorGuides={false} />}
          </Image>
        )}
      </ImageContainer>
    </>
  );
});
